export const newslettersData = [
  {
    key: "1",
    EMAIL: "andrew@example.com",
    DATE: "24 Jan 2025",
    FIELD3: "Delete",
  },
  {
    key: "2",
    EMAIL: "david@example.com",
    DATE: "19 Dec 2024",
    FIELD3: "Delete",
  },
  {
    key: "3",
    EMAIL: "phu@example.com",
    DATE: "11 Dec 2024",
    FIELD3: "Delete",
  },
  {
    key: "4",
    EMAIL: "walter@example.com",
    DATE: "29 Nov 2024",
    FIELD3: "Delete",
  },
  {
    key: "5",
    EMAIL: "jermaine@example.com",
    DATE: "03 Nov 2024",
    FIELD3: "Delete",
  },
  {
    key: "6",
    EMAIL: "dennis@example.com",
    DATE: "31 Oct 2024",
    FIELD3: "Delete",
  },
  {
    key: "7",
    EMAIL: "lan@example.com",
    DATE: "15 Oct 2024",
    FIELD3: "Delete",
  },
  {
    key: "8",
    EMAIL: "crump@example.com",
    DATE: "26 Sep 2024",
    FIELD3: "Delete",
  },
  {
    key: "9",
    EMAIL: "julie@example.com",
    DATE: "01 Sep 2024",
    FIELD3: "Delete",
  },
  {
    key: "10",
    EMAIL: "jean@example.com",
    DATE: "15 Aug 2024",
    FIELD3: "Delete",
  },
];
